<template>
    <div>
        <b-container fluid class="headerBg">
            <b-container>
                <b-row class="header">
                    <b-col cols="auto">
                        <router-link to="/">
                            <img src="/logo.png" alt="Logotype" class="logo" draggable="false">
                        </router-link>
                    </b-col>
                    <b-col class="d-flex justify-content-end">
                        <ul class="menu">
                            <li class="menu_item" v-for="(link, index) in locale.headerMenu" :key="'menu_item_'+index">
                                <router-link :to="{name: link.to}">{{ link.title}}</router-link>
                            </li>
                        </ul>
                        <i class="mobile_menu-btn"
                               :class="{'fas fa-times': menuVisible, 'fas fa-bars': !menuVisible}"
                               @click="menuVisible = !menuVisible">
                            <span></span>
                            <span></span>
                            <span></span>
                        </i>
                    </b-col>
                    <b-col cols="auto" class="lang_box">
                        <div class="ml-3 lang" :class="{'active': language === 'nl'}">
                            <img @click="setLang('nl')" width="20" src="/flags/nl.svg" alt="">
                        </div>
                        <div class="ml-3 lang" :class="{'active': language === 'en'}">
                            <img @click="setLang('en')" width="20" src="/flags/en.svg" alt="">
                        </div>
                        <div class="ml-3 lang" :class="{'active': language === 'ru'}">
                            <img @click="setLang('ru')" width="20" src="/flags/ru.svg" alt="">
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <b-container fluid class="mobile_menu-box">
            <b-container>
                <b-row>
                    <b-col>
                        <b-collapse id="mobile_menu" v-model="menuVisible">
                            <ul class="mobile_menu">
                                <li class="mobile_menu-item"
                                    v-for="(link, index) in locale.headerMenu" :key="'menu_item_'+index">
                                    <router-link :to="{name: link.to}">{{ link.title}}</router-link>
                                </li>
                                <li class="d-flex py-3">
                                    <div class="ml-3 lang" :class="{'active': language === 'nl'}">
                                        <img @click="setLang('nl')" width="20" src="/flags/nl.svg" alt="">
                                    </div>
                                    <div class="ml-3 mb-1 lang" :class="{'active': language === 'en'}">
                                        <img @click="setLang('en')" width="20" src="/flags/en.svg" alt="">
                                    </div>
                                    <div class="ml-3 mb-1 lang" :class="{'active': language === 'ru'}">
                                        <img @click="setLang('ru')" width="20" src="/flags/ru.svg" alt="">
                                    </div>
                                </li>
                            </ul>
                        </b-collapse>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <div class="feedback_btn" @click="toggleFeedModal">
            <img src="/images/phone.svg" alt="phone">
        </div>
        <b-modal id="feedModal" v-if="locale.modal" centered hide-footer>
            <template v-slot:modal-title>
                <div class="d-flex justify-content-between">
                    <img src="/logo.png" alt="Logotype" class="logo mr-5" draggable="false">
<!--                    <p class="m-0">{{locale.modal.title}}</p>-->
                </div>
            </template>
            <b-form @submit.prevent="sendCallback">
                <div class="mb-2">
                    <p class="m-0">{{locale.modal.name}} ?</p>
                    <b-input v-model="feed.name" :placeholder="locale.modal.name"></b-input>
                </div>
                <div class="mb-2">
                    <p class="m-0">{{locale.modal.email}} </p>
                    <b-input v-model="feed.email" :placeholder="locale.modal.email"></b-input>
                </div>
                <div class="mb-2">
                    <p class="m-0">{{locale.modal.phone}} </p>
                    <b-input v-model="feed.phone" :placeholder="locale.modal.phone"></b-input>
                </div>
                <div class="mt-4 d-flex justify-content-end">
                    <b-btn variant="outline-secondary" class="mr-2">{{locale.modal.cancel}}</b-btn>
                    <b-btn variant="custom-green" type="submit">{{locale.modal.submit}}</b-btn>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {mapGetters} from 'vuex'
    export default {
        data(){
            return{
                locale: {},
                menuVisible: false,
                feed: {
                    name: null,
                    email: null,
                    phone: null
                }
            }
        },
        methods: {
            setLang(lang){
                localStorage.setItem('lang', lang)
                this.$router.push({query: { lang: lang}})
                this.setLanguage(lang)
            },
            ...mapActions({
                setLanguage: 'setLanguage'
            }),
            sendCallback(){
                this.axios.post('/callback.php', this.feed)
            },
            toggleFeedModal(){
                this.$root.$emit('bv::toggle::modal', 'feedModal')
            }
        },
        created() {
            this.axios.get('/locale/header/'+ this.language +'.json').then(res => {
                this.locale = res.data
            })
        },
        computed: {
            ...mapGetters({
                language : 'getLanguage'
            })
        },
        watch: {
            '$route.query' : function() {
                this.axios.get('/locale/header/'+ this.language +'.json').then(res => {
                    this.locale = res.data
                })
            },
            $route: function () {
                this.menuVisible = false
            }
        }
    }
</script>

<style scoped>
    .header{
        height: 60px;
        display: flex;
        align-items: center;

    }
    .headerBg{
        background-color: #4d4b4b;
        z-index: 12;
        box-shadow: 0 0 6px -3px #ffffff;
    }
    .logo{
        max-width: 140px;
    }
    .lang{
        width: 20px;
        height: 20px;
        display: flex;
    }
    .lang_box{
        display: flex;
    }
    .active img{
        box-shadow: 0 0 8px 0 #ffffff;
        border-radius: 50%;
    }
    .menu{
        list-style-type: none;
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
    }
    .menu .menu_item{
        flex: 1;
        min-width: 20%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .menu .menu_item a{
        color: #ffffff;
        text-decoration: none;
        outline: none;
    }
    .router-link-active{
        color: #79a723 !important;
    }
    #feedModal p{
        font-size: 14px;
        color: var(--secondary);
    }
    #feedModal input{
        outline: none;
        box-shadow: none;
    }
    #feedModal input::placeholder{
        font-size: 12px;
        color: lightgray;
    }
    #feedModal input:focus{
        border-color: #79a723;
    }
    .feedback_btn{
        width: 50px;
        height: 50px;
        border: 1px solid #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        position: fixed;
        bottom: 20px;
        right: 20px;
        cursor: pointer;
        background-color: #4d4b4b;
    }
    .feedback_btn img{
        width: 25px;
        animation: vibration 10s infinite ease;
    }
    @keyframes vibration {
        0%{
            transform: translateX(0px);
        }
        1%{
            transform: translateX(-5px);
        }
        2%{
            transform: translateX(5px);
        }
        3%{
            transform: translateX(-3px);
        }
        4%{
            transform: translateX(3px);
        }
        5%{
            transform: translateX(-1px);
        }
        6%{
            transform: translateX(1px);
        }
        7%{
            transform: translateX(0px);
        }
        100%{
            transform: translateX(0px);
        }
    }
    @media screen and (max-width: 992px){
        .menu, .lang_box{
            display: none;
        }
        .mobile_menu{
            list-style-type: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .mobile_menu-box{
            background-color: #4d4b4b;
        }
        .mobile_menu .mobile_menu-item{
            margin: 10px 0;
        }
        .mobile_menu .mobile_menu-item a{
            color: #fff;
        }
        .mobile_menu-btn span{
            display: block;
            width: 18px;
            height: 2px;
            margin: 3px 0;
            background: #ffffff;
            transition: all .3s ease;
        }
        .mobile_menu-btn.fa-times span{
            transform: rotate(-45deg) translateY(-3px);
            transform-origin: center;
        }
        .mobile_menu-btn.fa-times span:nth-child(1){
            display: none;
        }
        .mobile_menu-btn.fa-times span:nth-child(2){
            transform: rotate(45deg) translateY(3px);
            transform-origin: center;
        }
    }
</style>


<style>
    .mt-60-px{
        margin-top: 60px;
    }
    .btn-custom-green{
        background: transparent !important;
        border-color: #79a723 !important;
        color: #79a723 !important;
    }
    .btn-custom-green:hover{
        background: #79a723 !important;
        border-color: #79a723 !important;
        color: #ffffff !important;
    }
</style>